import React from 'react';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import PropTypes from 'prop-types';
import { ListItem, ListItemText, Collapse, List } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import Typography from '@material-ui/core/Typography';

const CollapseSubItem = props => {
    const { text, subItems, classes, submenuCollapseSelected, menuselectedcollapse, open, setOpen, } = props

    const handleClick = () => {

        setOpen(!open);
        // menuCollapseSelected(text)
    };
    return (
        <div>
            <ListItem onClick={handleClick} button selected={false}
                className={(text === 
                    // menuselectedsimple
                    'Pago de Servicios'
                ) ? classes.menuactive : classes.menudesactive}
            >

                <ListItemText primary={<Typography
                    component="span"
                    variant="body3"
                    className={classes.fontsize}
                >
                    {text}
                </Typography>} className={(text === 
                    // menuselectedsimple
                    'Pago de Servicios'
                    ) ? classes.listItemsactive : classes.listItems} />
                {(text === 
                    // menuselectedsimple
                    'Pago de Servicios'
                    ) ? <ExpandLess style={{ color: "rgba(255, 198, 0)" }} /> : <ExpandMore style={{ color: "rgba(255, 198, 0)" }} />}
            </ListItem>
            <Collapse
                in={(text === 
                    // menuselectedsimple
                    'Pago de Servicios'
                ) ? true : false}
                timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {
                        subItems.map(subItem => {
                            // console.log(subItem);



                            const { stext, sroute, state } = subItem

                            if (state) {
                                return <ListItem key={stext} button={(isMobile) ? false : true} onClick={() => submenuCollapseSelected(sroute, stext, text)} className={(stext === menuselectedcollapse) ? classes.listSubItemsactivebackground : classes.listSubItemsdesactivebackground} >

                                    <ListItemText primary={<Typography
                                        component="span"
                                        variant="body2"
                                        className={classes.fontsize}
                                    >
                                        {stext}
                                    </Typography>} className={(stext === menuselectedcollapse) ? classes.listSubItemsactive : classes.listItemsdesactive} />
                                </ListItem>
                            } else { return null }
                        })
                    }
                </List>
            </Collapse>
        </div>
    );
};

CollapseSubItem.propTypes = {
    icon: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    subItems: PropTypes.array.isRequired,
    onSendData: PropTypes.func.isRequired,
};

export default CollapseSubItem;